// extracted by mini-css-extract-plugin
module.exports = {"title":"Documents_title__7Tj4V","selects":"Documents_selects__vhm4n"};